module.exports = __webpack_public_path__ + "static/media/navigation.70b89749.css";


//////////////////
// WEBPACK FOOTER
// /src/lib/navigation.css
// module id = 396
// module chunks = 0